/* eslint no-shadow: ["error", { "allow": ["state"] }] */

// initial state
export const state = {
    all: [],
};

// getters
const getters = {};

// actions
const actions = {};

let notificationIndex = 0;
// mutations
export const mutations = {
    // Notification Data supports:
    /*
        type:
            ['info', 'success', 'warning', 'error', ''(untyped)] - Decides colour
        actionName:
            String - What the main action of the notification shows
        message:
            String - Main Body
        customTitle:
            String [Optional, Defaults to the type name capitalized] - Title of notification
        action:
            Function - Function which will execute on a main button press
    */
    pushNotification(state, notificationData) {
        const notification = notificationData;
        notification.id = notificationData.id || notificationIndex;
        notificationIndex += 1;
        notification.created = (new Date()).getTime();
        setTimeout(() => {
            state.all = state.all.filter(item => item !== notification);
        }, 6000);
        state.all.push(notification);
    },
    removeNotification(state, id) {
        state.all = state.all.filter(item => item.id !== id);
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
